import { useAppSelector } from "../redux/hooks";
import { browserTimeZone } from "../utils";

const useSelectedAccount = () => {
  const selectedAccount = useAppSelector((state) => state.user.selectedAccount);

  return {
    selectedAccount,
    accountId: selectedAccount?.accountId ?? null,
    timezone: selectedAccount?.timezone ?? browserTimeZone,
  };
};

export default useSelectedAccount;
